export default {"src":"/_next/static/media/reading-map.mono.ef5250de.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};